export default function (_this) {
  return {
    /**
     * Create new tab for certain dashboard
     * @param {string} dashKey - dashboard id where new tab created
     * @param {number} curLength - current length of dashboard tabs to add order num to new created tab
     * @param {function} callback - callback function that called when everything is done
     */
    create (dashKey, curLength, callback) {
      const newTab = {
        title: 'New Tab',
        order: curLength || 0
      }

      const key = _this.dashRef.child(`${dashKey}/tabs`)
        .push(newTab, (err) => {
          if (!callback) return

          if (err) callback(err)
          else callback(null, key)
        }).key
    },
    read (callback) {
      let tabs = {}
      _this.getRef('tabs').orderByChild('order').on('value', (snapshot) => {
        tabs = {}
        snapshot.forEach((child) => {
          tabs[child.key] = child.val()
        })
        callback(tabs)
      })
    },
    rename (tab, newTitle, callback) {
      _this.getRef('tabs').child(tab + '/title').set(newTitle, (err) => {
        if (err) callback(err)
        else callback(null)
      })
    },
    delete (key, callback) {
      new Promise((resolve) => {
        _this.getRef('tabs').child(key).remove((err) => {
          if (err) callback(err)
          else resolve()
        })
      }).then(() => {
        _this.getRef('tabs').orderByChild('order').once('value', (snapshot) => {
          const newOrderedTabs = {}
          let count = 0

          snapshot.forEach((child) => {
            const tab = child.val()
            tab.order = count++
            newOrderedTabs[child.key] = tab
          })

          _this.getRef('tabs').set(newOrderedTabs, (err) => {
            if (err) callback(err)
            else callback()
          })
        })
      })

      _this.getRef('widgets').orderByChild('tab').equalTo(key).on('value', (snapshot) => {
        let data = snapshot.val()

        for (let key in data) {
          _this.widgets.delete(key, data[key]['dependencies'])
        }
      })
    },
    setTabOnLoad (tab) {
      _this.getRef('tabOnLoad').set(tab)
    },
    setPrivateTab (tabs) {
      _this.getRef('privateTabs').set(tabs)
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/db/tabs.js